const customExperienceActionTypes = {
  FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES: "FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES",
  FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES_SUCCESS: "FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES_SUCCESS",
  FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES_FAILURE: "FETCH_MARKETPLACE_CUSTOMER_EXPERIENCES_FAILURE",
  FETCH_SHOP_CUSTOMER_EXPERIENCES: "FETCH_SHOP_CUSTOMER_EXPERIENCES",
  FETCH_SHOP_CUSTOMER_EXPERIENCES_SUCCESS: "FETCH_SHOP_CUSTOMER_EXPERIENCES_SUCCESS",
  FETCH_SHOP_CUSTOMER_EXPERIENCES_FAILURE: "FETCH_SHOP_CUSTOMER_EXPERIENCES_FAILURE",
  DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE: "DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE",
  DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE_SUCCESS: "DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE_SUCCESS",
  DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE_FAILURE: "DUPLICATE_MARKETPLACE_CUSTOMER_EXPERIENCE_FAILURE",
  DUPLICATE_SHOP_CUSTOMER_EXPERIENCE: "DUPLICATE_SHOP_CUSTOMER_EXPERIENCE",
  DUPLICATE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS: "DUPLICATE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS",
  DUPLICATE_SHOP_CUSTOMER_EXPERIENCE_FAILURE: "DUPLICATE_SHOP_CUSTOMER_EXPERIENCE_FAILURE",
  CREATE_SHOP_CUSTOMER_EXPERIENCE: "CREATE_SHOP_CUSTOMER_EXPERIENCE",
  CREATE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS: "CREATE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS",
  CREATE_SHOP_CUSTOMER_EXPERIENCE_FAILURE: "CREATE_SHOP_CUSTOMER_EXPERIENCE_FAILURE",
  DELETE_SHOP_CUSTOMER_EXPERIENCE: "DELETE_SHOP_CUSTOMER_EXPERIENCE",
  DELETE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS: "DELETE_SHOP_CUSTOMER_EXPERIENCE_SUCCESS",
  DELETE_SHOP_CUSTOMER_EXPERIENCE_FAILURE: "DELETE_SHOP_CUSTOMER_EXPERIENCE_FAILURE",
  CLEAR_SHOP_CUSTOMER_EXPERIENCES: "CLEAR_SHOP_CUSTOMER_EXPERIENCES",
  FETCH_CUSTOMER_EXPERIENCE: "FETCH_CUSTOMER_EXPERIENCE",
  FETCH_CUSTOMER_EXPERIENCE_SUCCESS: "FETCH_CUSTOMER_EXPERIENCE_SUCCESS",
  FETCH_CUSTOMER_EXPERIENCE_FAILURE: "FETCH_CUSTOMER_EXPERIENCE_FAILURE",
  UPDATE_CUSTOMER_EXPERIENCE: "UPDATE_CUSTOMER_EXPERIENCE",
  UPDATE_CUSTOMER_EXPERIENCE_SUCCESS: "UPDATE_CUSTOMER_EXPERIENCE_SUCCESS",
  UPDATE_CUSTOMER_EXPERIENCE_FAILURE: "UPDATE_CUSTOMER_EXPERIENCE_FAILURE",
  FETCH_LOCATIONS: "FETCH_LOCATIONS",
  FETCH_LOCATIONS_SUCCESS: "FETCH_LOCATIONS_SUCCESS",
  FETCH_LOCATIONS_FAILURE: "FETCH_LOCATIONS_FAILURE",
};

export default customExperienceActionTypes;
